import { render, staticRenderFns } from "./PickupOption.vue?vue&type=template&id=67b90876&scoped=true&"
import script from "./PickupOption.vue?vue&type=script&lang=js&"
export * from "./PickupOption.vue?vue&type=script&lang=js&"
import style0 from "./PickupOption.vue?vue&type=style&index=0&id=67b90876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b90876",
  null
  
)

export default component.exports